<template>
  <div>
    <div class="iBodyCont">
      <Carousel/>

      <div class="iBodyWrap">
        <iVideo/>
        <iWorkLog :modders="modderList"/>
        <iNews/>

        <div class="iVoteWrap">
          <div class="ti"><font-awesome-icon :icon="[`fas`, `chart-bar`]"/>&nbsp;&nbsp;Results&nbsp;&nbsp;<span style="font-size:13px;">Pre Event Predictions - Week 1</span></div>
          <div class="iVoteTabsBox">
            <highcharts :options="chartOptions"/>
          </div>
        </div>

        <gSponsor/>
      </div>
    </div>

  </div>
</template>

<script>
import Carousel from '@/components/Carousel.vue'
import iVideo from '@/components/iVideo.vue'
import iWorkLog from '@/components/iWorkLog.vue'
import iNews from '@/components/iNews.vue'
import gSponsor from '@/components/gSponsor.vue'
/* highcharts 區域註冊 */
// https://ithelp.ithome.com.tw/articles/10251641?sc=pt
// https://github.com/highcharts/highcharts-vue
import { Chart } from 'highcharts-vue'

export default {
  components: {
    Carousel,
    iVideo,
    iWorkLog,
    iNews,
    gSponsor,
    highcharts: Chart
  },
  data () {
    return {
      id: {},
      modderList: [],
      chartOptions: {
        chart: {
          type: 'column',
          backgroundColor: null
        },
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        series: [{
          color: '#606060',
          name: 'Vote',
          data: []
        }],
        xAxis: {
          gridLineColor: '#606060',
          categories: [],
          title: {
            text: null
          },
          labels: {
            style: {
              color: '#dadada',
              fontFamily: 'Calibri, Arial, Helvetica, sans-serif',
              fontSize: '15px'
            }
          }
        },
        yAxis: {
          gridLineColor: '#777777',
          min: 0,
          title: {
            text: null,
            align: 'high'
          },
          labels: {
            overflow: 'justify',
            style: {
              color: '#777777',
              fontFamily: 'Calibri, Arial, Helvetica, sans-serif',
              fontSize: '13px'
            }
          }
        },
        tooltip: {
          valueSuffix: ' Votes of total'
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        }
      }
    }
  },
  watch: {
    // 監聽路由有變化就執行後面函式
    // '$route': 'getModder'
    $route (to, from) {
      this.getModderLang();
    },
  },
  methods: {
    getModderLang () {
      let fetchJson;
      console.log('this.currentLang', this.$route.params.lang)
      if(this.$route.params.lang === 'tw') { // 這邊判斷式不能用 data 的 currentLang，似乎不會隨切換語系更新 data，所以不會變化
        fetchJson = fetch('./modder/tw.json')
      } else if(this.$route.params.lang === 'cn') {
        fetchJson = fetch('./modder/cn.json')
      } else {
        fetchJson = fetch('./modder/en.json')
      }
      fetchJson
      .then(rs => rs.json())
      .then(rs => {
        console.log('modder', rs)
        this.modderList = rs
        this.chartOptions.series[0].data = rs.reduce((acc, val) => acc.concat(val.votes), []) // 用這個可以找到陣列裡面的東西，也可以攤平深層陣列
        this.chartOptions.xAxis.categories = rs.reduce((acc, val) => acc.concat(val.name), [])
      })
    },
  },
  created () {
    this.getModderLang();
    // fetch('./data.json') // 放在 public 方便修改 // 隨手Note：fetch用相對路徑找不到放在assets裡面的data.json檔，可能要用絕對路徑才可以
    //   .then(rs => rs.json())
    //   .then(rs => {
    //     // console.log('modder', rs)
    //     this.modderList = rs
    //     this.chartOptions.series[0].data = rs.reduce((acc, val) => acc.concat(val.votes), []) // 用這個可以找到陣列裡面的東西，也可以攤平深層陣列
    //     this.chartOptions.xAxis.categories = rs.reduce((acc, val) => acc.concat(val.name), [])
    //     // this.chartOptions.series[0].data = rs.map(val => ({
    //     //   map找不到陣列裡面的東西
    //     // }))
    //     // console.log('chartOptions', this.chartOptions.series[0].data)
    //   })
    //   this.id = this.$route.params.lang;
    //   console.log('HomeView', this.id)
  },
  mounted () {

  }

}
</script>
